import React, { ReactNode, FC } from "react";

import { ToggleAnimator } from "@/design-system/components/animation/ToggleAnimator";
import { AnimationConfig } from "@/design-system/components/animation/types";
import { EmotionClassStyles } from "@/domains/emotion/types";

export interface LoadingAnimatorProps extends EmotionClassStyles {
  loading: boolean;
  loadingElement: ReactNode;
  readyElement: ReactNode;
  animationConfig?: AnimationConfig;
}

/**
 * Starts by showing the `loadingElement`.
 *
 * When `loading` flips from false to true, we start fading out `loadingElement`.
 *
 * After `loadingElement` fades out, we hide it (display=none) then begin fading-in
 * the `readyElement`.
 *
 * @deprecated - Use the newer MDS components instead.
 *
 * - If something doesn't exist yet, please create a new MDS component and
 *   have it reviewed by the team!
 *
 * - If something needs to hook into our `stores`, add it to the /components directory.
 *
 * - If something is a one-off; please colocate it with the component/page that
 *   needs it.
 *
 * - If you have questions, please ask in the #hub-eng-web-team Slack channel.
 */
export const LoadingAnimator: FC<LoadingAnimatorProps> = ({
  loading,
  loadingElement,
  readyElement,
  ...rest
}) => {
  return (
    <ToggleAnimator
      {...rest}
      toggled={!loading}
      falseElement={loadingElement}
      trueElement={readyElement}
    />
  );
};
